//import $ from 'jquery'
//import { gsap, CSSPlugin, ScrollToPlugin } from "gsap/all";
//import { Power4 } from "gsap";
//gsap.registerPlugin(ScrollToPlugin);
let global = {
  init: function () {

  },
};
export default global;
